import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {ref} from "vue";
import SogButton from "@/shared/ui/SogButton.vue";
import {SogButtonKind} from "@/shared/ui/types/SogButtonKind";
import {SogButtonType} from "@/shared/ui/types/SogButtonType";
import {SogButtonStyle} from "@/shared/ui/types/SogButtonStyle";

interface Props {
  mdiIcon?: string
  disabled?: boolean | string
  eIcon?: string
  svgIcon?:string
  tooltip?: string
  kind?:SogButtonKind,
  buttonStyle?:SogButtonStyle
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*@__PURE__*/_defineComponent({
  __name: 'SogCardActionButton',
  props: {
    mdiIcon: { default: "" },
    disabled: { type: [Boolean, String], default: false },
    eIcon: { default: undefined },
    svgIcon: { default: undefined },
    tooltip: { default: undefined },
    kind: { default: SogButtonKind.Default },
    buttonStyle: { default: SogButtonStyle.Default }
  },
  emits: ['click'],
  setup(__props: any, { expose: __expose }) {



const props = __props

const obj = ref<InstanceType<typeof SogButton>  | null>(null)

const focus = ()=>{
  obj.value?.focus();
}

__expose({
  focus
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogButton, {
    ref_key: "obj",
    ref: obj,
    class: "sog-card-action-button",
    type: _unref(SogButtonType).Card,
    disabled: __props.disabled,
    "mdi-icon": __props.mdiIcon,
    "e-icon": __props.eIcon,
    tooltip: __props.tooltip,
    kind: __props.kind,
    "svg-icon": __props.svgIcon,
    style: {"align-self":"flex-end"},
    "button-style": __props.buttonStyle,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click')))
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["type", "disabled", "mdi-icon", "e-icon", "tooltip", "kind", "svg-icon", "button-style"]))
}
}

})